import moment from 'moment';

export default {
  openProjects(state) {
    return state.data.map((project) => {
      // TODO: This should really be updatedAt - need to update once that data is coming in
      const createdAt = project.created;
      const formatDate = moment(createdAt).format('MMM Do, YYYY');
      return {
        ...project,
        created: formatDate,
      };
    });
  },
  projectId(state, getters, rootState) { return rootState.route.params.projectId; },
  currentProject(state, getters, rootState) {
    return state.data
      .filter(project => project._id === rootState.route.params.projectId || project._id === state.currentProjectId)
      .pop();
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/projects/getters.js